import React, { useState } from 'react';

function PhotographerLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/photographer/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });

      const data = await res.json();
      if (res.ok && data.success) {
        onLogin();
      } else {
        setError(data.detail || 'Invalid username or password');
      }
    } catch (err) {
      setError('Failed to connect to the server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-bg2 p-8 rounded-3xl border border-borderBase shadow-glow max-w-md w-full">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-extrabold mb-2 text-white">Photographer Access</h2>
        <p className="text-textMuted">Login to upload event photos</p>
      </div>

      <form onSubmit={handleLogin} className="flex flex-col gap-5">
        <div>
          <label className="block text-sm font-medium text-textMuted mb-2">Username</label>
          <input
            type="text"
            className="w-full bg-bg3 border border-borderBase rounded-xl px-5 py-3 text-white focus:outline-none focus:border-accentSolid transition-colors"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-textMuted mb-2">Password</label>
          <input
            type="password"
            className="w-full bg-bg3 border border-borderBase rounded-xl px-5 py-3 text-white focus:outline-none focus:border-accentSolid transition-colors"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {error && <p className="text-red-400 text-sm mt-1">{error}</p>}

          <button
            type="submit"
            className="w-full bg-accent-gradient text-white px-6 py-4 rounded-xl font-bold shadow-glow hover:-translate-y-1 hover:shadow-glow-strong transition-all active:translate-y-px text-lg disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Enter Dashboard'}
          </button>
      </form>
    </div>
  );
}

export default PhotographerLogin;
